import { Model, type ModelProps } from '@/infra/model'
import { observable } from 'mobx'
import { Id } from '@/infra/id'
import { unixEpoch } from '@/utils/date-util'

export type TxfJobProps = ModelProps<TxfJob>

export class TxfJob extends Model<TxfJob> {
  jobId = Id.none

  @observable accessor createdAt = unixEpoch()
  @observable accessor modifiedAt = unixEpoch()
}
